export default __webpack_public_path__ + "static/media/diameter.98ac7ff7.png";